module.exports = __webpack_public_path__ + "img/1.9acb798a.png";